export const demoPreview = {
  badgeLabel: 'Demo preview',
  /** Phone and tablet: must hold one line at 360px. */
  bannerMessageShort: 'Unofficial demo. We remove it on request.',
  /** Desktop, where the full disclosure fits on the same single line. */
  bannerMessage: "Unofficial concept by JMR Squared, not this business's own website. We remove it on request.",
  attributionCreditLabel: 'Unsolicited demo preview by',
  attributionContext:
    'An unsolicited concept by JMR Squared, built to show what a website for this business could look like. It is not the official website and is not endorsed by the business. We remove it on request.',
} as const;
